export enum ApprovalStatus {
  PENDING = 'Pending',
  APPROVED_CRO = 'ApprovedCRO',
  APPROVED_APPROVER = 'Approved',
  REJECTED_CRO = 'RejectedCRO',
  REJECTED_APPROVER = 'Rejected',
  PRIVATE = 'Private',
}

export function getStatusDisplayName(status: ApprovalStatus, needsDiscountApproval: boolean): string {
  switch (status) {
    case ApprovalStatus.PENDING:
      return 'Waiting Export Approval';
    case ApprovalStatus.APPROVED_CRO:
      return needsDiscountApproval ? 'Waiting Discount Approval' : 'Approved Export';
    case ApprovalStatus.APPROVED_APPROVER:
      return 'Approved Discount';
    case ApprovalStatus.REJECTED_CRO:
      return 'Rejected Export';
    case ApprovalStatus.REJECTED_APPROVER:
      return 'Rejected Discount';
    case ApprovalStatus.PRIVATE:
      return 'Draft';
    default:
      return status;
  }
}

export interface Preset {
  id: number;
  name: string;
  user: string;
  company: string;
  set: string;
  paintProvided: string;
  discountToDisplay: string;
  extraDiscount: number;
  unitDiscount: number;
  overallDiscount: number;
  margin: number;
  unitDiscountEnabled: string;
  approvalStatus: ApprovalStatus;
  reason: string;
  rejectionReason: string;
  paintDiscount: number;
  cleanDiscount: number;
  carpetCleanDiscount: number;
  maintenanceDiscount: number;
  saasUnitFee: number;
  saasContractedUnits: number;
  saasFeePeriod: string;
  saasPeriodCost: number;
  saasFeeEnabled: string;
  created: string;
  lastUpdated: string;
}
